export const GmailIcon = () => {
    return (
        <svg width="16" height="16" viewBox="-3 -3 30 30" fill="currentColor">
            <path
                fill="currentColor"
                d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64L12
                9.548l6.545-4.91l1.528-1.145C21.69 2.28 24 3.434 24 5.457"
            />
        </svg>
    );
};
